import { ReactElement } from "react";
import { resolveProperty } from "@animech/axiom-utility";
import {
	FieldComponentBuilderArgs,
	FieldPipe,
	FieldPipeMeta,
	UiComponentBuildContext,
	UiComponentBuilder,
} from "@animech/axiom-ui-builder";
import { StockAwareHorizontalCardSelect } from "../components/widgets/horizontal-card-select";
import { Root } from "@definitions";
import { HorizontalCardSelectNode } from "src/definitions/ui-definitions";

type ComponentBuilderArgs = FieldComponentBuilderArgs<
	Root,
	HorizontalCardSelectNode
>;

export class HorizontalCardSelectComponentBuilder
	implements UiComponentBuilder<Root, HorizontalCardSelectNode>
{
	private _args: ComponentBuilderArgs;

	constructor(args: ComponentBuilderArgs) {
		this._args = { ...args };
	}

	public build(
		node: HorizontalCardSelectNode,
		context: UiComponentBuildContext<Root>,
	) {
		const { getFieldNodeMeta, getFieldNodeValueMeta } = this._args;

		if (node.state) {
			const property = resolveProperty(node.state, context.activeProperty);
			return (
				<FieldPipe
					key={`${node.id}:${context.activeProperty}`}
					property={property}
					write
				>
					<FieldPipeMeta
						getFieldMeta={(property) => getFieldNodeMeta(node, property)}
						getFieldValueMeta={getFieldNodeValueMeta}
					>
						{this._render(node)}
					</FieldPipeMeta>
				</FieldPipe>
			);
		} else {
			return this._render(node);
		}
	}

	private _render(node: HorizontalCardSelectNode): ReactElement {
		const { state, type, id, visible, ...props } = node;

		return <StockAwareHorizontalCardSelect {...props} />;
	}
}
